import ImagingModule from "../imaging";
import {agendaDirectory} from "../access/patientDirectory";
import {
  getDateKeyInTimeZone,
  getDeviceTimeZone,
  localizeScheduleEntry
} from "../utils/timezone";
import {usePatientRecord} from "../access/usePatientRecord";
import {useAccess} from "../access/useAccess";
import {
  useEffect,
  useState
} from "react";

import {
  collection,
  doc,
  onSnapshot,
  query,
  updateDoc,
  where
} from "../access/firestore";

import {
  db
} from "../firebase";

import {
  useClinic
} from "../context/ClinicContext";

import {
  ArrowLeft,
  UserRound,
  CalendarDays,
  CircleDollarSign,
  ClipboardList,
  Stethoscope,
  Camera,
  ScanLine,
  Smile,
  FileCheck2,
  Pill,
  MessageCircle,
  History,
  ClipboardPlus,
  CalendarPlus,
  CreditCard
} from "lucide-react";

import HistoriaClinicaPanel
  from "../HistoriaClinicaPanel";

import CambraPanel
  from "../components/patients/CambraPanel";

import EvolutionPanel
  from "../EvolutionPanel";

import FotosPanel
  from "../FotosPanel";

import MobileOdontograma
  from "./MobileOdontograma";

import MobilePeriodontograma
  from "./MobilePeriodontograma";

import MobileRecetas
  from "./MobileRecetas";

import OrtodonciaPanel
  from "../OrtodonciaPanel";

import ConsentimientosPanel
  from "../ConsentimientosPanel";

import PrescriptionPanel
  from "../PrescriptionPanelDashboard";

import PatientWhatsAppPanel
  from "../PatientWhatsAppPanel";

import PlanTratamientoPanel
  from "../components/patients/PlanTratamientoPanel";

import {
  registerPayment
} from "../services/registerPayment";

import PdfViewerModal
  from "../PdfViewerModal";

import CitaForm
  from "../CitaForm";

export default function MobilePacienteDetalle({

  paciente:initialPatient,
  onBack

}) {
  const {patient:paciente}=usePatientRecord(initialPatient);
  const {can}=useAccess();
  const tabAllowed=id=>id==="general"?can("patients"):id==="ortodoncia"?["ceph","bolton","stl","aligners"].some(key=>can(key)):can(({historiaClinica:"history",cambra:"history",plan:"treatment",evolucion:"evolution",fotos:"photos",odontograma:"odontogram",periodonto:"periodonto",consentimientos:"consents",recetas:"prescriptions",whatsapp:"whatsapp",tomografias:"imaging"})[id]);


  const {
    clinicId,
    clinicData
  } = useClinic();
  const deviceTimeZone = getDeviceTimeZone();


  const [
    pacienteActual,
    setPacienteActual
  ] = useState(
    paciente || null
  );


  const [
    tab,
    setTab
  ] = useState(
    "general"
  );

  const [
      mostrarAyudaModulos,
      setMostrarAyudaModulos
  ] = useState(true);

  const [
    generalSubTab,
    setGeneralSubTab
  ] = useState(
    "datosPersonales"
  );


  const [
    mostrarCitaForm,
    setMostrarCitaForm
  ] = useState(false);

  
  const [
    citas,
    setCitas
  ] = useState([]);

  const [
    pagos,
    setPagos
  ] = useState([]);

  useEffect(() => {

    if (
      !clinicId ||
      !pacienteActual?.id
    ) {

      setPagos([]);

      return;

    }

    const pagosQuery =
      query(
        collection(
          db,
          "clinics",
          clinicId,
          "pagos"
        ),
        where(
          "pacienteId",
          "==",
          pacienteActual.id
        )
      );

    return onSnapshot(
      pagosQuery,
      snapshot => {

        setPagos(
          snapshot.docs.map(
            item => localizeScheduleEntry({
              id: item.id,
              ...item.data()
            }, deviceTimeZone)
          )
        );

      },
      error => {

        console.error(
          "Error cargando pagos de evolución:",
          error
        );

        setPagos([]);

      }
    );

  }, [
    clinicId,
    pacienteActual?.id,
    deviceTimeZone
  ]);


  useEffect(() => {

    if (
      !clinicId ||
      !pacienteActual?.id
    ) {

      setCitas([]);

      return;

    }

    const citasQuery =
      query(
        agendaDirectory(db,clinicId),
        where(
          "pacienteId",
          "==",
          pacienteActual.id
        )
      );

    return onSnapshot(
      citasQuery,
      snapshot => {

        setCitas(
          snapshot.docs.map(
            item => localizeScheduleEntry({
              id: item.id,
              ...item.data()
            }, deviceTimeZone)
          )
        );

      }
    );

  }, [
    clinicId,
    pacienteActual?.id,
    deviceTimeZone
  ]);


  const formatearFecha =
    fecha => {

      if (!fecha) {
        return "Sin información";
      }

      const partes =
        String(fecha).split("-");

      if (partes.length !== 3) {
        return fecha;
      }

      const [
        anio,
        mes,
        dia
      ] = partes;

      const meses = [
        "enero",
        "febrero",
        "marzo",
        "abril",
        "mayo",
        "junio",
        "julio",
        "agosto",
        "septiembre",
        "octubre",
        "noviembre",
        "diciembre"
      ];

      const numeroMes =
        Number(mes) - 1;

      if (
        numeroMes < 0 ||
        numeroMes > 11
      ) {
        return fecha;
      }

      return `${Number(dia)} de ${meses[numeroMes]} de ${anio}`;

    };


  const hoy =
    new Date();

  const hoyKey = getDateKeyInTimeZone(hoy, deviceTimeZone);


  const proximaCita =
    citas
      .filter(
        cita =>
          cita.estado === "activa" &&
          cita.fecha &&
          cita.fecha >= hoyKey
      )
      .sort(
        (a, b) => {

          const fechaA =
            `${a.fecha || ""}T${a.hora || "00:00"}`;

          const fechaB =
            `${b.fecha || ""}T${b.hora || "00:00"}`;

          return (
            new Date(fechaA) -
            new Date(fechaB)
          );

        }
      )[0] || null;


  const [
    saldoPendiente,
    setSaldoPendiente
  ] = useState(
    Number(
      paciente?.saldoPendiente || 0
    )
  );


  useEffect(() => {

    if (
      !paciente?.id ||
      !clinicId
    ) {
      return;
    }

    return onSnapshot(

      collection(
        db,
        "clinics",
        clinicId,
        "pacientes",
        paciente.id,
        "cuentasPorCobrar"
      ),

      snapshot => {

        const saldoPendiente =
          snapshot.docs.reduce(
            (
              total,
              item
            ) => {

              const cuenta =
                item.data();

              return (
                total +
                Number(
                  cuenta.saldo || 0
                )
              );

            },
            0
          );


        setSaldoPendiente(
          saldoPendiente
        );

      },

      error => {

        console.error(
          "Error cargando saldo pendiente:",
          error
        );

      }

    );

  }, [
    clinicId,
    paciente?.id
  ]);


  useEffect(() => {

    if (
      !clinicId ||
      !paciente?.id
    ) {
      return;
    }

    const pacienteRef = doc(
      db,
      "clinics",
      clinicId,
      "pacientes",
      paciente.id
    );

    return onSnapshot(
      pacienteRef,
      snapshot => {

        if (
          snapshot.exists()
        ) {

          setPacienteActual(
            anterior => ({

              ...anterior,

              id:
                snapshot.id,

              ...snapshot.data()

            })
          );

        }

      }
    );

  }, [
    clinicId,
    paciente?.id
  ]);


  if (!pacienteActual) {

    return (

      <div
        style={{
          padding:20,
          textAlign:"center",
          color:"#64748b"
        }}
      >

        No se encontró
        el paciente.

      </div>

    );

  }


    const nombreCompleto = [

        pacienteActual.nombre,

        pacienteActual.apellidos

    ]

        .filter(Boolean)

        .join(" ");


    const telefono =
        String(
        pacienteActual.whatsapp ||
        pacienteActual.telefono ||
        ""
        )
        .replace(/\D/g, "")
        .replace(
            /^521(?=\d{10}$)/,
            ""
        )
        .replace(
            /^52(?=\d{10}$)/,
            "");


    const telefonoMostrar =
        telefono || "Sin teléfono";


  const guardarOdontograma =
    async nuevoOdontograma => {

      if (
        !clinicId ||
        !pacienteActual?.id
      ) {
        return;
      }

      setPacienteActual(
        anterior => ({
          ...anterior,

          odontograma:
            nuevoOdontograma

        })
      );

      try {

        await updateDoc(

          doc(
            db,
            "clinics",
            clinicId,
            "pacientes",
            pacienteActual.id
          ),

          {
            odontograma:
              nuevoOdontograma
          }

        );

      } catch (error) {

        console.error(
          "Error guardando odontograma:",
          error
        );

        alert(
          "No fue posible guardar el odontograma."
        );

      }

  };


  const allTabs = [

    {
      id:"general",
      label:"General",
      icon:UserRound
    },

    {
      id:"historiaClinica",
      label:"Historia clínica",
      icon:ClipboardList
    },

    {
      id:"cambra",
      label:"CAMBRA",
      icon:ClipboardList
    },

    {
      id:"plan",
      label:"Plan de tratamiento",
      icon:ClipboardPlus
    },

    {
      id:"evolucion",
      label:"Evolución",
      icon:History
    },

    {
      id:"fotos",
      label:"Fotografías",
      icon:Camera
    },

    {
      id:"odontograma",
      label:"Odontograma",
      icon:Smile
    },

    {
      id:"periodonto",
      label:"Periodontograma",
      icon:ScanLine
    },

    {
      id:"tomografias",
      label:"Tomografías",
      icon:ScanLine
    },

    {
      id:"ortodoncia",
      label:"Ortodoncia",
      icon:Stethoscope
    },

    {
      id:"consentimientos",
      label:"Consentimientos",
      icon:FileCheck2
    },

    {
      id:"recetas",
      label:"Recetas",
      icon:Pill
    },

    {
      id:"whatsapp",
      label:"WhatsApp",
      icon:MessageCircle
    }

  ];


  const tabs=allTabs.filter(item=>tabAllowed(item.id));

  const calcularEdad = fechaNacimiento => {

    if (!fechaNacimiento) {
      return 0;
    }

    let fecha;

    if (
      fechaNacimiento &&
      typeof fechaNacimiento.toDate === "function"
    ) {

      fecha =
        fechaNacimiento.toDate();

    } else if (
      fechaNacimiento instanceof Date
    ) {

      fecha =
        fechaNacimiento;

    } else {

      const valor =
        String(fechaNacimiento);

      const partes =
        valor.split("-");

      if (
        partes.length === 3 &&
        partes.every(
          parte =>
            !isNaN(
              Number(parte)
            )
        )
      ) {

        const [
          anio,
          mes,
          dia
        ] =
          partes.map(Number);

        fecha =
          new Date(
            anio,
            mes - 1,
            dia
          );

      } else {

        fecha =
          new Date(valor);

      }

    }

    if (
      isNaN(
        fecha.getTime()
      )
    ) {

      return 0;

    }

    const hoy =
      new Date();

    let edad =
      hoy.getFullYear() -
      fecha.getFullYear();

    const diferenciaMes =
      hoy.getMonth() -
      fecha.getMonth();

    if (
      diferenciaMes < 0 ||
      (
        diferenciaMes === 0 &&
        hoy.getDate() <
          fecha.getDate()
      )
    ) {

      edad--;

    }

    return Math.max(
      0,
      edad
    );

  };


  return (

    <div
      className="vd-mobile-patient-detail"
      style={{
        minHeight:"100%",
        background:"#f8fafc",
        paddingBottom:20
      }}
    >

      <div
        className="vd-mobile-patient-detail-sticky"
        style={{
          position:"sticky",
          top:0,
          zIndex:20,
          padding:"10px 14px 12px",
          background:"#f8fafc"
        }}
      >

        <div
          className="vd-mobile-patient-detail-hero"
          style={{
            position:"relative",
            overflow:"hidden",
            borderRadius:24,
            padding:"14px 16px 16px",
            background:"linear-gradient(135deg, #2563eb 0%, #1d4ed8 58%, #1e40af 100%)",
            boxShadow:"0 12px 28px rgba(37,99,235,0.22)"
          }}
        >

          <div
            style={{
              position:"absolute",
              width:150,
              height:150,
              borderRadius:"50%",
              background:"rgba(255,255,255,0.08)",
              top:-85,
              right:-50
            }}
          />

          <div
            style={{
              position:"absolute",
              width:90,
              height:90,
              borderRadius:"50%",
              background:"rgba(255,255,255,0.06)",
              bottom:-55,
              left:-30
            }}
          />

          <button
            type="button"
            onClick={onBack}
            style={{
              position:"relative",
              zIndex:2,
              display:"flex",
              alignItems:"center",
              gap:7,
              border:"none",
              background:"transparent",
              padding:0,
              color:"rgba(255,255,255,0.86)",
              fontSize:13,
              fontWeight:700,
              cursor:"pointer",
              marginBottom:14
            }}
          >

            <ArrowLeft
              size={18}
            />

            Pacientes

          </button>


          <div
            style={{
              position:"relative",
              zIndex:2,
              display:"flex",
              alignItems:"center",
              gap:12
            }}
          >

            <div
              style={{
                width:54,
                height:54,
                borderRadius:17,
                background:"rgba(255,255,255,0.16)",
                border:"1px solid rgba(255,255,255,0.22)",
                display:"flex",
                alignItems:"center",
                justifyContent:"center",
                flexShrink:0,
                boxShadow:"0 6px 16px rgba(15,23,42,0.12)"
              }}
            >

              <UserRound
                size={27}
                color="#ffffff"
                strokeWidth={2}
              />

            </div>


            <div
              style={{
                minWidth:0,
                flex:1
              }}
            >

              <div
                style={{
                  fontSize:20,
                  fontWeight:800,
                  color:"#ffffff",
                  lineHeight:1.15,
                  overflow:"hidden",
                  textOverflow:"ellipsis",
                  whiteSpace:"nowrap",
                  letterSpacing:"-0.3px"
                }}
              >

                {
                  nombreCompleto ||
                  "Paciente"
                }

              </div>


              <div
                style={{
                  marginTop:5,
                  fontSize:12,
                  color:"rgba(255,255,255,0.78)",
                  overflow:"hidden",
                  textOverflow:"ellipsis",
                  whiteSpace:"nowrap"
                }}
              >

                {
                  calcularEdad(
                    pacienteActual.fechaNacimiento
                  ) > 0
                    ? `${calcularEdad(
                        pacienteActual.fechaNacimiento
                      )} años`
                    : "Paciente"
                }

                {" · "}

                {telefono}

              </div>

            </div>

          </div>


          <button
            type="button"
            onClick={() =>
              setMostrarCitaForm(true)
            }
            style={{
              position:"relative",
              zIndex:2,
              marginTop:15,
              width:"100%",
              height:48,
              border:"none",
              borderRadius:15,
              background:"#ffffff",
              color:"#2563eb",
              display:"flex",
              alignItems:"center",
              justifyContent:"center",
              gap:8,
              fontSize:14,
              fontWeight:800,
              cursor:"pointer",
              boxShadow:"0 7px 18px rgba(15,23,42,0.14)"
            }}
          >

            <CalendarPlus
              size={19}
              strokeWidth={2.2}
            />

            Agendar nueva cita

          </button>

        </div>

      </div>


      <div
        style={{
          padding:"12px 16px 4px",
          display:"grid",
          gridTemplateColumns:
            "repeat(2, minmax(0, 1fr))",
          gap:10
        }}
      >

        <button
          type="button"
          onClick={() => {

            setTab("general");

            setGeneralSubTab(
              "historialCitas"
            );

          }}
          style={{
            border:"1px solid #dbeafe",
            borderRadius:17,
            padding:"14px",
            background:"#ffffff",
            textAlign:"left",
            boxShadow:
              "0 5px 16px rgba(15,23,42,0.045)",
            cursor:"pointer"
          }}
        >

          <div
            style={{
              display:"flex",
              alignItems:"center",
              gap:7,
              color:"#2563eb",
              marginBottom:8
            }}
          >

            <CalendarDays
              size={18}
            />

            <span
              style={{
                fontSize:11,
                fontWeight:800
              }}
            >
              PRÓXIMA CITA
            </span>

          </div>


          <div
            style={{
              fontSize:16,
              fontWeight:800,
              color:"#0f172a"
            }}
          >

            {
              proximaCita
                ? formatearFecha(
                    proximaCita.fecha
                  )
                : "Sin cita"
            }

          </div>


          <div
            style={{
              marginTop:5,
              fontSize:11,
              color:"#64748b",
              fontWeight:700
            }}
          >

            Ver historial de citas →

          </div>

        </button>


        <button
          type="button"
          onClick={() => {

            setTab("general");

            setGeneralSubTab(
              "historialFinanciero"
            );

          }}
          style={{
            border:
              saldoPendiente > 0
                ? "1px solid #fed7aa"
                : "1px solid #dcfce7",
            borderRadius:17,
            padding:"14px",
            background:"#ffffff",
            textAlign:"left",
            boxShadow:
              "0 5px 16px rgba(15,23,42,0.045)",
            cursor:"pointer"
          }}
        >

          <div
            style={{
              display:"flex",
              alignItems:"center",
              gap:7,
              color:
                saldoPendiente > 0
                  ? "#ea580c"
                  : "#16a34a",
              marginBottom:8
            }}
          >

            <CircleDollarSign
              size={18}
            />

            <span
              style={{
                fontSize:11,
                fontWeight:800
              }}
            >
              SALDO PENDIENTE
            </span>

          </div>


          <div
            style={{
              fontSize:18,
              fontWeight:800,
              color:"#0f172a",
              lineHeight:1.3
            }}
          >

            {
              `$${Number(
                saldoPendiente
              ).toLocaleString(
                "es-MX",
                {
                  minimumFractionDigits:2
                }
              )}`
            }

          </div>


          <div
            style={{
              marginTop:5,
              fontSize:11,
              color:"#d97706",
              fontWeight:700
            }}
          >

            Ver historial financiero →

          </div>

        </button>

      </div>


      <div
        style={{
          padding:"8px 16px 10px"
        }}
      >

        <div
          style={{
            fontSize:13,
            fontWeight:800,
            color:"#0f172a",
            marginBottom:9
          }}
        >

          Acciones rápidas

        </div>


        <div
          style={{
            display:"grid",
            gridTemplateColumns:
              "repeat(3, minmax(0, 100px))",
            justifyContent:"center",
            gap:10
          }}
        >

          <button
            type="button"
            onClick={() =>
              setMostrarCitaForm(true)
            }
            style={{
              border:"1px solid #dbeafe",
              borderRadius:15,
              background:"#ffffff",
              padding:"11px 5px",
              color:"#2563eb",
              display:"flex",
              flexDirection:"column",
              alignItems:"center",
              gap:6,
              fontSize:10,
              fontWeight:800,
              cursor:"pointer",
              boxShadow:
                "0 4px 12px rgba(15,23,42,0.04)"
            }}
          >

            <CalendarPlus
              size={20}
            />

            Agendar

          </button>


          <button
            type="button"
            onClick={() => {

              setTab("general");

              setGeneralSubTab(
                "historialFinanciero"
              );

            }}
            style={{
              border:"1px solid #fef3c7",
              borderRadius:15,
              background:"#ffffff",
              padding:"11px 5px",
              color:"#d97706",
              display:"flex",
              flexDirection:"column",
              alignItems:"center",
              gap:6,
              fontSize:10,
              fontWeight:800,
              cursor:"pointer",
              boxShadow:
                "0 4px 12px rgba(15,23,42,0.04)"
            }}
          >

            <CreditCard
              size={20}
            />

            Registrar pago

          </button>


          <button
            type="button"
            onClick={() =>
              setTab("whatsapp")
            }
            style={{
              border:"1px solid #dcfce7",
              borderRadius:15,
              background:"#ffffff",
              padding:"11px 5px",
              color:"#16a34a",
              display:"flex",
              flexDirection:"column",
              alignItems:"center",
              gap:6,
              fontSize:10,
              fontWeight:800,
              cursor:"pointer",
              boxShadow:
                "0 4px 12px rgba(15,23,42,0.04)"
            }}
          >

            <MessageCircle
              size={20}
            />

            WhatsApp

          </button>

        </div>

      </div>      
      
      <div style={{ padding: "10px 16px 4px" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 10,
            marginBottom: 8
          }}
        >
          <div>
            <div
              style={{
                fontSize: 9,
                fontWeight: 900,
                letterSpacing: 1.4,
                color: "#64748b",
                marginBottom: 3
              }}
            >
              EXPEDIENTE CLÍNICO
            </div>

            <div
              style={{
                fontSize: 19,
                fontWeight: 900,
                letterSpacing: "-0.6px",
                color: "#0f172a"
              }}
            >
              Explora tu expediente
            </div>
          </div>

          <div
            style={{
              width: 36,
              height: 36,
              flexShrink: 0,
              borderRadius: 12,
              background: "linear-gradient(135deg, #2563eb, #1d4ed8)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#fff",
              boxShadow: "0 5px 12px rgba(37,99,235,0.22)"
            }}
          >
            <ClipboardList size={19} />
          </div>
        </div>

        <div
          style={{
            background: "linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)",
            border: "1px solid #bfdbfe",
            borderRadius: 17,
            padding: "9px 10px 7px",
            boxShadow: "0 4px 12px rgba(37,99,235,0.06)"
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 8,
              marginBottom: 7
            }}
          >
            <div style={{ minWidth: 0 }}>
              <div
                style={{
                  color: "#64748b",
                  fontSize: 9,
                  fontWeight: 900,
                  letterSpacing: 1,
                  marginBottom: 2
                }}
              >
                ESTÁS EN
              </div>

              <div
                style={{
                  color: "#1d4ed8",
                  fontSize: 14,
                  fontWeight: 900,
                  overflowWrap: "anywhere"
                }}
              >
                {tabs.find(item => item.id === tab)?.label || "Expediente"}
              </div>
            </div>

            <div
              style={{
                flexShrink: 0,
                background: "#ffffff",
                border: "1px solid #bfdbfe",
                borderRadius: 10,
                padding: "5px 8px",
                color: "#2563eb",
                display: "flex",
                alignItems: "center",
                gap: 4,
                fontSize: 10,
                fontWeight: 900
              }}
            >
              {tabs.findIndex(item => item.id === tab) + 1}
              <span style={{ color: "#94a3b8" }}>/</span>
              {tabs.length}
            </div>
          </div>

          <div
            onScroll={() => setMostrarAyudaModulos(false)}
            role="navigation"
            aria-label="Módulos del expediente"
            style={{
              display: "flex",
              gap: 7,
              overflowX: "auto",
              padding: "2px 2px 6px",
              marginRight: -10,
              WebkitOverflowScrolling: "touch",
              scrollbarWidth: "none",
              scrollSnapType: "x proximity"
            }}
          >
            {tabs.map(item => {
              const Icon = item.icon;
              const active = tab === item.id;

              return (
                <button
                  key={item.id}
                  type="button"
                  aria-current={active ? "page" : undefined}
                  onClick={() => {
                    setTab(item.id);
                    setMostrarAyudaModulos(false);
                  }}
                  style={{
                    flex: "0 0 82px",
                    width: 82,
                    minWidth: 82,
                    minHeight: 68,
                    scrollSnapAlign: "start",
                    border: active
                      ? "1px solid #2563eb"
                      : "1px solid rgba(148,163,184,0.25)",
                    background: active
                      ? "linear-gradient(145deg, #3b82f6, #1d4ed8)"
                      : "#ffffff",
                    color: active ? "#ffffff" : "#475569",
                    borderRadius: 13,
                    padding: "7px 6px 6px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 4,
                    fontSize: 9,
                    fontWeight: 800,
                    lineHeight: 1.25,
                    textAlign: "center",
                    whiteSpace: "normal",
                    boxShadow: active
                      ? "0 5px 11px rgba(37,99,235,0.23)"
                      : "0 2px 5px rgba(15,23,42,0.03)",
                    transition: "background 160ms ease, box-shadow 160ms ease",
                    cursor: "pointer"
                  }}
                >
                  <div
                    style={{
                      width: 27,
                      height: 27,
                      borderRadius: 9,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      background: active
                        ? "rgba(255,255,255,0.19)"
                        : "#eff6ff",
                      color: active ? "#ffffff" : "#2563eb",
                      flexShrink: 0
                    }}
                  >
                    <Icon size={17} />
                  </div>

                  <span>{item.label}</span>
                </button>
              );
            })}
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 6,
              marginTop: 0
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 5,
                color: "#1d4ed8",
                fontSize: 10,
                fontWeight: 800,
                minWidth: 0
              }}
            >
              <span style={{ fontSize: 17, lineHeight: 1 }}>↔</span>
              <span>
                {mostrarAyudaModulos
                  ? "Desliza para descubrir más módulos"
                  : "Desliza para cambiar de módulo"}
              </span>
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 3,
                color: "#2563eb",
                fontSize: 16,
                fontWeight: 900,
                flexShrink: 0
              }}
            >
              <span>‹</span>
              <span>›</span>
            </div>
          </div>
        </div>
      </div>

      {
        tabAllowed(tab) && tab === "general" &&
        (

          <div
            style={{
              padding:
                "8px 16px 10px"
            }}
          >

            <div
              style={{
                display:"grid",
                gridTemplateColumns:
                  "repeat(4,minmax(0,1fr))",
                gap:5,
                padding:4,
                background:"#e2e8f0",
                borderRadius:14
              }}
            >

              <button
                type="button"
                onClick={() =>
                  setGeneralSubTab(
                    "datosPersonales"
                  )
                }
                style={{
                  border:"none",
                  borderRadius:10,
                  background:
                    generalSubTab ===
                    "datosPersonales"
                      ? "#ffffff"
                      : "transparent",
                  color:
                    generalSubTab ===
                    "datosPersonales"
                      ? "#2563eb"
                      : "#64748b",
                  padding:
                    "9px 4px",
                  fontSize:9,
                  fontWeight:900
                }}
              >

                Datos personales

              </button>


              <button
                type="button"
                onClick={() =>
                  setGeneralSubTab(
                    "datosClinicos"
                  )
                }
                style={{
                  border:"none",
                  borderRadius:10,
                  background:
                    generalSubTab ===
                    "datosClinicos"
                      ? "#ffffff"
                      : "transparent",
                  color:
                    generalSubTab ===
                    "datosClinicos"
                      ? "#2563eb"
                      : "#64748b",
                  padding:
                    "9px 4px",
                  fontSize:9,
                  fontWeight:900
                }}
              >

                Datos clínicos

              </button>


              <button
                type="button"
                onClick={() =>
                  setGeneralSubTab(
                    "historialCitas"
                  )
                }
                style={{
                  border:"none",
                  borderRadius:10,
                  background:
                    generalSubTab ===
                    "historialCitas"
                      ? "#ffffff"
                      : "transparent",
                  color:
                    generalSubTab ===
                    "historialCitas"
                      ? "#2563eb"
                      : "#64748b",
                  padding:
                    "9px 4px",
                  fontSize:9,
                  fontWeight:900
                }}
              >

                Historial de citas

              </button>


              <button
                type="button"
                onClick={() =>
                  setGeneralSubTab(
                    "historialFinanciero"
                  )
                }
                style={{
                  border:"none",
                  borderRadius:10,
                  background:
                    generalSubTab ===
                    "historialFinanciero"
                      ? "#ffffff"
                      : "transparent",
                  color:
                    generalSubTab ===
                    "historialFinanciero"
                      ? "#2563eb"
                      : "#64748b",
                  padding:
                    "9px 4px",
                  fontSize:9,
                  fontWeight:900
                }}
              >

                Historial financiero

              </button>

            </div>

          </div>

        )
      }


      {
        tabAllowed(tab) && tab === "general" &&
        generalSubTab ===
          "datosPersonales" &&
        (

          <div
            style={{
              padding:
                "0 16px 20px"
            }}
          >

            <div
              style={{
                background:"#ffffff",
                border:
                  "1px solid #e2e8f0",
                borderRadius:18,
                padding:16,
                boxShadow:
                  "0 4px 14px rgba(15,23,42,.04)"
              }}
            >

              <div
                style={{
                  fontSize:14,
                  fontWeight:900,
                  color:"#0f172a",
                  marginBottom:14
                }}
              >

                Datos personales

              </div>


              <div
                style={{
                  display:"grid",
                  gridTemplateColumns:
                    "repeat(2,minmax(0,1fr))",
                  gap:12
                }}
              >

                <div
                  style={{
                    gridColumn:"1 / -1"
                  }}
                >

                  <div
                    style={{
                      fontSize:10,
                      color:"#64748b",
                      fontWeight:800
                    }}
                  >

                    Nombre completo

                  </div>

                  <div
                    style={{
                      marginTop:4,
                      fontSize:13,
                      fontWeight:700
                    }}
                  >

                    {
                      nombreCompleto ||
                      "—"
                    }

                  </div>

                </div>


                <div>

                  <div
                    style={{
                      fontSize:10,
                      color:"#64748b",
                      fontWeight:800
                    }}
                  >

                    Edad

                  </div>

                  <div
                    style={{
                      marginTop:4,
                      fontSize:13,
                      fontWeight:700
                    }}
                  >

                    {
                      calcularEdad(
                        pacienteActual.fechaNacimiento
                      ) > 0
                        ? `${calcularEdad(
                            pacienteActual.fechaNacimiento
                          )} años`
                        : "—"
                    }

                  </div>

                </div>


                <div>

                  <div
                    style={{
                      fontSize:10,
                      color:"#64748b",
                      fontWeight:800
                    }}
                  >

                    Teléfono

                  </div>

                  <div
                    style={{
                      marginTop:4,
                      fontSize:13,
                      fontWeight:700
                    }}
                  >

                    {
                      telefonoMostrar ||
                      "—"
                    }

                  </div>

                </div>


                <div>

                  <div
                    style={{
                      fontSize:10,
                      color:"#64748b",
                      fontWeight:800
                    }}
                  >

                    Correo

                  </div>

                  <div
                    style={{
                      marginTop:4,
                      fontSize:13,
                      fontWeight:700,
                      wordBreak:"break-word"
                    }}
                  >

                    {
                      pacienteActual?.email ||
                      "—"
                    }

                  </div>

                </div>


                <div>

                  <div
                    style={{
                      fontSize:10,
                      color:"#64748b",
                      fontWeight:800
                    }}
                  >

                    Fecha de nacimiento

                  </div>

                  <div
                    style={{
                      marginTop:4,
                      fontSize:13,
                      fontWeight:700
                    }}
                  >

                    {
                      pacienteActual?.fechaNacimiento
                        ? formatearFecha(
                            pacienteActual.fechaNacimiento
                          )
                        : "—"
                    }

                  </div>

                </div>


                <div>

                  <div
                    style={{
                      fontSize:10,
                      color:"#64748b",
                      fontWeight:800
                    }}
                  >

                    Sexo

                  </div>

                  <div
                    style={{
                      marginTop:4,
                      fontSize:13,
                      fontWeight:700
                    }}
                  >

                    {
                      pacienteActual?.sexo ||
                      "—"
                    }

                  </div>

                </div>

              </div>

            </div>

          </div>

        )
      }


      {
        tabAllowed(tab) && tab === "general" &&
        generalSubTab ===
          "datosClinicos" &&
        (

          <div
            style={{
              padding:
                "0 16px 20px"
            }}
          >

            <HistoriaClinicaPanel
              paciente={
                pacienteActual
              }
              clinicId={
                clinicId
              }
            />

          </div>

        )
      }


      {
        tabAllowed(tab) && tab === "general" &&
        generalSubTab ===
          "historialCitas" &&
        (

          <div
            style={{
              padding:
                "0 16px 20px"
            }}
          >

            <div
              style={{
                background:"#ffffff",
                border:
                  "1px solid #e2e8f0",
                borderRadius:18,
                padding:16,
                boxShadow:
                  "0 4px 14px rgba(15,23,42,.04)"
              }}
            >

              <div
                style={{
                  display:"flex",
                  alignItems:"center",
                  justifyContent:"space-between",
                  gap:10
                }}
              >

                <div
                  style={{
                    display:"flex",
                    alignItems:"center",
                    gap:8,
                    fontSize:14,
                    fontWeight:900
                  }}
                >

                  <CalendarDays
                    size={18}
                    color="#2563eb"
                  />

                  Historial de citas

                </div>


                <button
                  type="button"
                  onClick={() =>
                    setMostrarCitaForm(
                      true
                    )
                  }
                  style={{
                    border:"none",
                    borderRadius:10,
                    background:"#eff6ff",
                    color:"#2563eb",
                    padding:
                      "8px 10px",
                    fontSize:10,
                    fontWeight:900
                  }}
                >

                  Nueva cita

                </button>

              </div>


              <div
                style={{
                  marginTop:14,
                  color:"#64748b",
                  fontSize:12
                }}
              >

                Las citas del paciente se
                muestran en la agenda.

              </div>

            </div>

          </div>

        )
      }


      {
        tabAllowed(tab) && tab === "general" &&
        generalSubTab ===
          "historialFinanciero" &&
        (

          <div
            style={{
              padding:
                "0 16px 20px"
            }}
          >

            <HistorialFinancieroMobile
              paciente={
                pacienteActual
              }
              clinicId={
                clinicId
              }
              clinicData={
                clinicData
              }
            />

          </div>

        )
      }


      {
        tabAllowed(tab) && tab === "historiaClinica" &&
        (

          <div
            style={{
              padding:
                "0 16px 20px"
            }}
          >

            <HistoriaClinicaPanel
              paciente={
                pacienteActual
              }
              clinicId={
                clinicId
              }
            />

          </div>

        )
      }

      {
        tabAllowed(tab) && tab === "cambra" &&
        (
          <div style={{padding:"0 16px 20px"}}>
            <CambraPanel
              paciente={pacienteActual}
            />
          </div>
        )
      }


      {
        tabAllowed(tab) && tab === "plan" &&
        (

          <div
            style={{
              padding:
                "0 16px 20px"
            }}
          >

            <PlanTratamientoPanel
              paciente={
                pacienteActual
              }
              clinicId={
                clinicId
              }
            />

          </div>

        )
      }


        {
          tabAllowed(tab) && tab === "evolucion" &&
          (
            <div
              style={{
                padding: "0 16px 20px",
                width: "100%",
                minWidth: 0,
                boxSizing: "border-box"
              }}
            >
            
            <EvolutionPanel
              paciente={pacienteActual}
              clinicId={clinicId}
              clinicData={clinicData}
              citas={citas}
              pagos={pagos}
            />

            </div>
          )
        }


        {
          tabAllowed(tab) && tab === "fotos" &&
          (
            <div
              style={{
                padding: "0 16px 20px",
                width: "100%",
                minWidth: 0,
                boxSizing: "border-box"
              }}
            >
              <FotosPanel
                pacienteId={pacienteActual?.id}
              />
            </div>
          )
        }


      {
        tabAllowed(tab) && tab === "odontograma" &&
        (

          <div
            style={{
              padding:
                "0 16px 20px"
            }}
          >

            <MobileOdontograma
              paciente={
                pacienteActual
              }
              clinicId={
                clinicId
              }
              onSave={
                guardarOdontograma
              }
            />

          </div>

        )
      }


      {
        tabAllowed(tab) && tab === "periodonto" &&
        (

          <div
            style={{
              padding:
                "0 16px 20px"
            }}
          >

            <MobilePeriodontograma
              paciente={
                pacienteActual
              }
              clinicId={
                clinicId
              }
            />

          </div>

        )
      }


      {
        tabAllowed(tab) && tab === "ortodoncia" &&
        (

          <div
            style={{
              padding:
                "0 16px 20px"
            }}
          >

            <OrtodonciaPanel
                pacienteId={
                    pacienteActual?.id
                }
                clinicId={
                    clinicId
                }
            />

          </div>

        )
      }


      {
        tabAllowed(tab) && tab === "tomografias" && pacienteActual?.id && (<div style={{padding:"0 16px 20px"}}><ImagingModule key={clinicId+":"+pacienteActual.id} patient={pacienteActual}/></div>)
      }

      {
        tabAllowed(tab) && tab === "consentimientos" &&
        (

          <div
            style={{
              padding:
                "0 16px 20px"
            }}
          >

            <ConsentimientosPanel
              paciente={
                pacienteActual
              }
              clinicId={
                clinicId
              }
            />

          </div>

        )
      }


      {
        tabAllowed(tab) && tab === "recetas" &&
        (

          <div
            style={{
              padding:
                "0 16px 20px"
            }}
          >

            <PrescriptionPanel
              patient={{
                ...pacienteActual,
                edad: calcularEdad(
                  pacienteActual?.fechaNacimiento
                )
              }}
              clinicId={clinicId}
            />

          </div>

        )
      }


      {
        tabAllowed(tab) && tab === "whatsapp" &&
        (

          <div
            style={{
              padding:
                "0 16px 20px"
            }}
          >

            <PatientWhatsAppPanel
              paciente={
                pacienteActual
              }
              clinicId={
                clinicId
              }
            />

          </div>

        )
      }


      {
        mostrarCitaForm &&
        (

          <CitaForm
            paciente={
              pacienteActual
            }
            onClose={() =>
              setMostrarCitaForm(
                false
              )
            }
          />

        )
      }

    </div>

  );

}


function HistorialFinancieroMobile({

  paciente,
  clinicId,
  clinicData

}) {

  const [
    pagos,
    setPagos
  ] = useState([]);


  const [
    cuentasPorCobrar,
    setCuentasPorCobrar
  ] = useState([]);


  const [
    modoPago,
    setModoPago
  ] = useState(false);


  const [
    cuentaSeleccionadaId,
    setCuentaSeleccionadaId
  ] = useState("");


  const [
    abono,
    setAbono
  ] = useState("");


  const [
    metodoPago,
    setMetodoPago
  ] = useState(
    "efectivo"
  );


  const [
    enviarReciboWhatsApp,
    setEnviarReciboWhatsApp
  ] = useState(true);


  const [
    registrandoPago,
    setRegistrandoPago
  ] = useState(false);


  const [
    searchPago,
    setSearchPago
  ] = useState("");


  const [
    pdfViewerOpen,
    setPdfViewerOpen
  ] = useState(false);


  const [
    pdfViewerUrl,
    setPdfViewerUrl
  ] = useState("");


  const [
    pdfViewerTitle,
    setPdfViewerTitle
  ] = useState("");


  const [
    pdfViewerFileName,
    setPdfViewerFileName
  ] = useState("");


  useEffect(() => {

    if (
      !paciente?.id ||
      !clinicId
    ) {

      setPagos([]);

      return;

    }


    const pagosQuery =
      query(

        collection(
          db,
          "clinics",
          clinicId,
          "pagos"
        ),

        where(
          "pacienteId",
          "==",
          paciente.id
        )

      );


    return onSnapshot(

      pagosQuery,

      snapshot => {

        setPagos(

          snapshot.docs.map(
            item => ({

              id:item.id,

              ...item.data()

            })
          )

        );

      },

      () => {

        setPagos([]);

      }

    );

  }, [
    clinicId,
    paciente?.id
  ]);


  useEffect(() => {

    if (
      !paciente?.id ||
      !clinicId
    ) {

      setCuentasPorCobrar([]);

      return;

    }


    return onSnapshot(

      collection(
        db,
        "clinics",
        clinicId,
        "pacientes",
        paciente.id,
        "cuentasPorCobrar"
      ),

      snapshot => {

        setCuentasPorCobrar(

          snapshot.docs.map(
            item => ({

              id:item.id,

              ...item.data()

            })
          )

        );

      },

      () => {

        setCuentasPorCobrar([]);

      }

    );

  }, [
    clinicId,
    paciente?.id
  ]);


  const formatearMoneda =
    valor =>

      new Intl.NumberFormat(
        "es-MX",
        {
          style:"currency",
          currency:"MXN"
        }
      ).format(
        Number(
          valor || 0
        )
      );


  const cuentasPendientes =
    cuentasPorCobrar.filter(

      cuenta =>

        Number(
          cuenta.saldo || 0
        ) > 0

    );


  const totalPresupuesto =
    cuentasPorCobrar.reduce(

      (
        total,
        cuenta
      ) =>

        total +
        Number(
          cuenta.total || 0
        ),

      0

    );


  const totalPagado =
    cuentasPorCobrar.reduce(

      (
        total,
        cuenta
      ) =>

        total +
        Number(
          cuenta.pagado || 0
        ),

      0

    );


  const saldo =
    cuentasPorCobrar.reduce(

      (
        total,
        cuenta
      ) =>

        total +
        Number(
          cuenta.saldo || 0
        ),

      0

    );

  const registrarPago =
    async () => {

      if (registrandoPago) {
        return;
      }

      if (!cuentaSeleccionadaId) {

        alert(
          "Selecciona un concepto."
        );

        return;

      }

      const cuenta =
        cuentasPorCobrar.find(
          item =>
            item.id ===
            cuentaSeleccionadaId
        );

      if (!cuenta) {

        alert(
          "No se encontró la cuenta seleccionada."
        );

        return;

      }

      const pagoMonto =
        Number(abono);

      if (
        !pagoMonto ||
        pagoMonto <= 0
      ) {

        alert(
          "Ingresa una cantidad válida."
        );

        return;

      }

      const saldoActual =
        Number(
          cuenta.saldo || 0
        );

      if (
        pagoMonto >
        saldoActual
      ) {

        alert(
          "El pago no puede ser mayor al saldo pendiente."
        );

        return;

      }

      const cita = {

        id:
          cuenta.id,

        cuentaPorCobrarId:
          cuenta.id,

        citaId:
          cuenta.citaId ||
          null,

        motivo:
          cuenta.descripcion ||
          cuenta.folio ||
          "Pago",

        presupuesto:
          Number(
            cuenta.total || 0
          ),

        saldo:
          saldoActual,

        pagado:
          Number(
            cuenta.pagado || 0
          ),

        tipo:
          cuenta.tipo ||
          "planTratamiento"

      };

      try {

        setRegistrandoPago(
          true
        );

        await registerPayment({

          clinicId,

          clinicData,

          paciente: {
            ...paciente,
            whatsapp:
              paciente.whatsapp ||
              paciente.telefono ||
              ""
          },

          cuenta: cuenta,

          monto: pagoMonto,

          metodoPago,

          enviarReciboWhatsApp

        });

        setModoPago(
          false
        );

        setCuentaSeleccionadaId(
          ""
        );

        setAbono("");

      } catch (error) {

        alert(
          error.message ||
          "No fue posible registrar el pago."
        );

      } finally {

        setRegistrandoPago(
          false
        );

      }

  };


  return (

    <div>

      <SectionCard
        title="Resumen financiero"
      >

        <div
          style={{
            display:"grid",
            gridTemplateColumns:
              "repeat(3, minmax(0, 1fr))",
            gap:8
          }}
        >

          <SummaryCard
            label="Total"
            value={
              formatearMoneda(
                totalPresupuesto
              )
            }
            icon={
              <CircleDollarSign
                size={17}
              />
            }
          />

          <SummaryCard
            label="Pagado"
            value={
              formatearMoneda(
                totalPagado
              )
            }
            icon={
              <CircleDollarSign
                size={17}
              />
            }
          />

          <SummaryCard
            label="Pendiente"
            value={
              formatearMoneda(
                saldo
              )
            }
            icon={
              <CircleDollarSign
                size={17}
              />
            }
          />

        </div>

      </SectionCard>


      <SectionCard
        title="Cuentas por cobrar"
      >

        <button
          type="button"
          onClick={() => {

            setCuentaSeleccionadaId("");

            setAbono("");

            setMetodoPago("efectivo");

            setEnviarReciboWhatsApp(true);

            setModoPago(true);

          }}
          style={{
            width:"100%",
            marginBottom:12,
            minHeight:44,
            border:"none",
            borderRadius:12,
            background:"#2563eb",
            color:"#ffffff",
            fontSize:13,
            fontWeight:800,
            cursor:"pointer"
          }}
        >
          Registrar pago
        </button>

        {
          cuentasPorCobrar.length === 0
            ? (

              <div
                style={{
                  padding:"18px 0",
                  textAlign:"center",
                  color:"#64748b",
                  fontSize:13
                }}
              >

                No hay cuentas por cobrar.

              </div>

            )
            : (

              <div
                style={{
                  display:"flex",
                  flexDirection:"column",
                  gap:9
                }}
              >

                {
                  cuentasPorCobrar.map(
                    cuenta => (

                      <div
                        key={
                          cuenta.id
                        }
                        style={{
                          border:
                            "1px solid #e2e8f0",
                          borderRadius:14,
                          padding:13,
                          background:"#ffffff"
                        }}
                      >

                        <div
                          style={{
                            display:"flex",
                            justifyContent:"space-between",
                            gap:10
                          }}
                        >

                          <div
                            style={{
                              minWidth:0,
                              flex:1
                            }}
                          >

                            <div
                              style={{
                                fontSize:13,
                                fontWeight:800,
                                color:"#111827"
                              }}
                            >

                              {
                                cuenta.concepto ||
                                cuenta.descripcion ||
                                "Cuenta"
                              }

                            </div>


                            <div
                              style={{
                                marginTop:4,
                                fontSize:11,
                                color:"#64748b"
                              }}
                            >

                              Total:{" "}
                              {
                                formatearMoneda(
                                  cuenta.total
                                )
                              }

                            </div>

                          </div>


                          <div
                            style={{
                              textAlign:"right"
                            }}
                          >

                            <div
                              style={{
                                fontSize:14,
                                fontWeight:900,
                                color:
                                  Number(
                                    cuenta.saldo ||
                                    0
                                  ) > 0
                                    ? "#c2410c"
                                    : "#15803d"
                              }}
                            >

                              {
                                formatearMoneda(
                                  cuenta.saldo
                                )
                              }

                            </div>


                            <div
                              style={{
                                marginTop:3,
                                fontSize:10,
                                color:"#64748b"
                              }}
                            >

                              pendiente

                            </div>

                          </div>

                        </div>

                      </div>

                    )
                  )
                }

              </div>

            )

        }

      </SectionCard>


      <SectionCard
        title="Pagos registrados"
      >

        {
          pagos.length === 0
            ? (

              <div
                style={{
                  padding:"18px 0",
                  textAlign:"center",
                  color:"#64748b",
                  fontSize:13
                }}
              >

                No hay pagos registrados.

              </div>

            )
            : (

              <div
                style={{
                  display:"flex",
                  flexDirection:"column",
                  gap:9
                }}
              >

                {
                  pagos
                    .filter(
                      pago => {

                        if (
                          !searchPago
                        ) {
                          return true;
                        }

                        const texto =
                          JSON.stringify(
                            pago
                          )
                            .toLowerCase();

                        return texto.includes(
                          searchPago.toLowerCase()
                        );

                      }
                    )
                    .map(
                      pago => (

                        <div
                          key={
                            pago.id
                          }
                          style={{
                            border:
                              "1px solid #e2e8f0",
                            borderRadius:14,
                            padding:13,
                            background:"#ffffff"
                          }}
                        >

                          <div
                            style={{
                              display:"flex",
                              justifyContent:"space-between",
                              gap:10
                            }}
                          >

                            <div>

                              <div
                                style={{
                                  fontSize:13,
                                  fontWeight:800
                                }}
                              >

                                {
                                  pago.concepto ||
                                  pago.descripcion ||
                                  "Pago"
                                }

                              </div>


                              <div
                                style={{
                                  marginTop:4,
                                  fontSize:11,
                                  color:"#64748b"
                                }}
                              >

                                {
                                  pago.metodoPago ||
                                  pago.metodo ||
                                  "Método no registrado"
                                }

                              </div>

                            </div>


                            <div
                              style={{
                                fontSize:14,
                                fontWeight:900,
                                color:"#15803d"
                              }}
                            >

                              +
                              {
                                formatearMoneda(
                                  pago.monto
                                )
                              }

                            </div>

                          </div>

                        </div>

                      )
                    )

                }

              </div>

            )

        }

      </SectionCard>


      {
        modoPago &&
        (

          <div
            style={{
              position:"fixed",
              inset:0,
              zIndex:30000,
              background:
                "rgba(15,23,42,.48)",
              display:"flex",
              alignItems:"flex-end",
              justifyContent:"center",
              padding:
                "16px 16px calc(96px + env(safe-area-inset-bottom))"
            }}
          >

            <div
              style={{
                width:"100%",
                maxWidth:520,
                maxHeight:"88vh",
                overflowY:"auto",
                background:"#ffffff",
                borderRadius:22,
                padding:18,
                boxShadow:
                  "0 20px 60px rgba(15,23,42,.25)"
              }}
            >

              <div
                style={{
                  display:"flex",
                  alignItems:"center",
                  justifyContent:"space-between",
                  gap:10,
                  marginBottom:16
                }}
              >

                <div
                  style={{
                    fontSize:17,
                    fontWeight:900,
                    color:"#0f172a"
                  }}
                >

                  Registrar pago

                </div>


                <button
                  type="button"
                  onClick={() =>
                    setModoPago(false)
                  }
                  style={{
                    width:36,
                    height:36,
                    border:"none",
                    borderRadius:10,
                    background:"#f1f5f9",
                    color:"#475569",
                    fontSize:20,
                    cursor:"pointer"
                  }}
                >

                  ×

                </button>

              </div>


              <div
                style={{
                  display:"grid",
                  gap:12
                }}
              >

                <div>

                  <label
                    style={{
                      display:"block",
                      marginBottom:6,
                      fontSize:11,
                      fontWeight:800,
                      color:"#475569"
                    }}
                  >
                    Concepto
                  </label>


                  <select
                    value={
                      cuentaSeleccionadaId
                    }
                    onChange={event =>
                      setCuentaSeleccionadaId(
                        event.target.value
                      )
                    }
                    style={{
                      width:"100%",
                      minHeight:46,
                      border:
                        "1px solid #cbd5e1",
                      borderRadius:11,
                      padding:
                        "0 12px",
                      background:"#ffffff",
                      fontSize:13
                    }}
                  >

                    <option value="">
                      Selecciona un concepto
                    </option>


                    {
                      cuentasPendientes.map(
                        cuenta => (

                          <option
                            key={
                              cuenta.id
                            }
                            value={
                              cuenta.id
                            }
                          >

                            {
                              cuenta.concepto ||
                              cuenta.descripcion ||
                              "Cuenta"
                            }

                            {" — "}

                            {
                              formatearMoneda(
                                cuenta.saldo
                              )
                            }

                          </option>

                        )
                      )
                    }

                  </select>

                </div>


                <div>

                  <label
                    style={{
                      display:"block",
                      marginBottom:6,
                      fontSize:11,
                      fontWeight:800,
                      color:"#475569"
                    }}
                  >
                    Monto
                  </label>


                  <input
                    type="number"
                    min="0"
                    step="0.01"
                    value={
                      abono
                    }
                    onChange={event =>
                      setAbono(
                        event.target.value
                      )
                    }
                    style={{
                      width:"100%",
                      minHeight:46,
                      boxSizing:"border-box",
                      border:
                        "1px solid #cbd5e1",
                      borderRadius:11,
                      padding:
                        "0 12px",
                      fontSize:14
                    }}
                  />

                </div>


                <div>

                  <label
                    style={{
                      display:"block",
                      marginBottom:6,
                      fontSize:11,
                      fontWeight:800,
                      color:"#475569"
                    }}
                  >
                    Método de pago
                  </label>


                  <select
                    value={
                      metodoPago
                    }
                    onChange={event =>
                      setMetodoPago(
                        event.target.value
                      )
                    }
                    style={{
                      width:"100%",
                      minHeight:46,
                      border:
                        "1px solid #cbd5e1",
                      borderRadius:11,
                      padding:
                        "0 12px",
                      background:"#ffffff",
                      fontSize:13
                    }}
                  >

                    <option value="efectivo">
                      Efectivo
                    </option>

                    <option value="tarjeta">
                      Tarjeta
                    </option>

                    <option value="transferencia">
                      Transferencia
                    </option>

                  </select>

                </div>


                <label
                  style={{
                    display:"flex",
                    alignItems:"center",
                    gap:9,
                    fontSize:12,
                    fontWeight:700,
                    color:"#334155"
                  }}
                >

                  <input
                    type="checkbox"
                    checked={
                      enviarReciboWhatsApp
                    }
                    onChange={event =>
                      setEnviarReciboWhatsApp(
                        event.target.checked
                      )
                    }
                  />

                  Enviar recibo por WhatsApp

                </label>


                <div
                  style={{
                    display:"grid",
                    gridTemplateColumns:
                      "1fr 1fr",
                    gap:9,
                    marginTop:4
                  }}
                >

                  <button
                    type="button"
                    onClick={() =>
                      setModoPago(false)
                    }
                    style={{
                      minHeight:46,
                      border:
                        "1px solid #cbd5e1",
                      borderRadius:12,
                      background:"#ffffff",
                      color:"#475569",
                      fontSize:13,
                      fontWeight:800
                    }}
                  >

                    Cancelar

                  </button>


                  <button
                    type="button"
                    onClick={
                      registrarPago
                    }
                    disabled={
                      registrandoPago
                    }
                    style={{
                      minHeight:46,
                      border:"none",
                      borderRadius:12,
                      background:"#2563eb",
                      color:"#ffffff",
                      fontSize:13,
                      fontWeight:800,
                      opacity:
                        registrandoPago
                          ? .65
                          : 1
                    }}
                  >

                    {
                      registrandoPago
                        ? "Registrando..."
                        : "Registrar pago"
                    }

                  </button>

                </div>

              </div>

            </div>

          </div>

        )
      }


      {
        pdfViewerOpen &&
        (

          <PdfViewerModal
            open={
              pdfViewerOpen
            }
            url={
              pdfViewerUrl
            }
            title={
              pdfViewerTitle
            }
            fileName={
              pdfViewerFileName
            }
            onClose={() =>
              setPdfViewerOpen(
                false
              )
            }
          />

        )
      }

    </div>

  );

}


function SectionCard({

  title,
  children

}) {

  return (

    <div
      style={{
        marginBottom:12,
        background:"#ffffff",
        border:
          "1px solid #e2e8f0",
        borderRadius:18,
        padding:16,
        boxShadow:
          "0 4px 14px rgba(15,23,42,.04)"
      }}
    >

      {
        title &&
        (

          <div
            style={{
              marginBottom:12,
              fontSize:14,
              fontWeight:900,
              color:"#0f172a"
            }}
          >

            {title}

          </div>

        )
      }


      {children}

    </div>

  );

}


function SummaryCard({

  label,
  value,
  icon

}) {

  return (

    <div
      style={{
        minWidth:0,
        padding:11,
        borderRadius:13,
        background:"#f8fafc",
        border:
          "1px solid #e2e8f0"
      }}
    >

      <div
        style={{
          display:"flex",
          alignItems:"center",
          gap:5,
          color:"#64748b",
          fontSize:9,
          fontWeight:800,
          textTransform:"uppercase"
        }}
      >

        {icon}

        {label}

      </div>


      <div
        style={{
          marginTop:5,
          fontSize:14,
          fontWeight:900,
          color:"#0f172a"
        }}
      >

        {value}

      </div>

    </div>

  );

}


function InfoRow({

  label,
  value

}) {

  return (

    <div
      style={{
        paddingBottom:10,
        marginBottom:10,
        borderBottom:
          "1px solid #f1f5f9"
      }}
    >

      <div
        style={{
          fontSize:10,
          color:"#64748b",
          fontWeight:800
        }}
      >

        {label}

      </div>


      <div
        style={{
          marginTop:4,
          fontSize:13,
          color:"#0f172a",
          fontWeight:600,
          wordBreak:"break-word"
        }}
      >

        {value}

      </div>

    </div>

  );

}
